const GAME_FONT_HREF = 'https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@500;600;700&family=Noto+Sans+SC:wght@300;400;500;700&family=JetBrains+Mono:wght@400;500&family=Ma+Shan+Zheng&family=Liu+Jian+Mao+Cao&display=swap'

let requested = false

/**
 * 中文、等宽与手写字族只有游戏内的 vg-studio 主题用到（见 styles/trpg/visual-tokens.css）。
 * 放在 index.html 里首页也要付这 270 KB 传输，移动端是 1.5 秒管道时间，而首页一个字都用不上。
 */
export function loadGameFonts() {
  if (requested) return
  requested = true
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = GAME_FONT_HREF
  document.head.appendChild(link)
}
